module.exports = __webpack_public_path__ + "static/media/hall-void-2026.96ff2c87.svg";